export default __webpack_public_path__ + "static/media/people-at-table.2cfdbb59.png";